import MyBackend from './my';
import SwanBackend from './swan';
import TtBackend from './tt';
import WxBackend from './wx';
function auto() {
    // order matters
    if (typeof tt !== 'undefined') {
        return TtBackend;
    }
    if (typeof my !== 'undefined') {
        return MyBackend;
    }
    if (typeof swan !== 'undefined') {
        return SwanBackend;
    }
    if (typeof wx !== 'undefined') {
        return WxBackend;
    }
    throw new Error('unsupported mini program');
}
export default auto();
//# sourceMappingURL=auto.js.map